import React from 'react';
import TooltipIconButton from './TooltipIconButton';

interface ConditionalTooltipIconButtonProps {
    isActive: boolean;
    onClick: () => void;
    activeIcon: React.ReactNode;
    inactiveIcon: React.ReactNode;
    activeTooltip: string;
    inactiveTooltip: string;
    iconProps?: { [key: string]: string };
}

const ConditionalTooltipIconButton = ({
    isActive,
    onClick,
    activeIcon,
    inactiveIcon,
    activeTooltip,
    inactiveTooltip,
    iconProps,
}: ConditionalTooltipIconButtonProps) => (
    <TooltipIconButton
        onClick={onClick}
        icon={isActive ? activeIcon : inactiveIcon}
        tooltip={isActive ? activeTooltip : inactiveTooltip}
        iconProps={iconProps}
    />
);

export default ConditionalTooltipIconButton;
